import { render, staticRenderFns } from "./AttributesListForm.vue?vue&type=template&id=2bc087ba"
import script from "./AttributesListForm.vue?vue&type=script&lang=js"
export * from "./AttributesListForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports